import { Box, Grid2, Skeleton, Typography } from "@mui/material";
import React from "react";
import TextBankInfo from "../common/TextBankInfo";
import TextBankInfoValue from "../common/TextBankInfoValue";

export default function TransferPayment({
  selectedbank = {},
  amount = 0,
  loading = true,
  setLoading = () => {},
  orderId = "",
}) {
  return (
    <Box display="flex" flexDirection="column" gap={2}>
      <Box
        sx={{
          bgcolor: "background.default",
          minHeight: 250,
          color: "black",
          borderRadius: "16px",
          padding: "24px",
        }}
      >
        <Typography variant="body" fontWeight={500}>
          Payment Information
        </Typography>
        <Grid2 container marginTop={2} spacing={1}>
          <Grid2 size={6}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              gap={2}
            >
              <TextBankInfo>Account Holder:</TextBankInfo>
              <TextBankInfo>Account Number:</TextBankInfo>
              <TextBankInfo>Bank Name:</TextBankInfo>
              <TextBankInfo>Amount:</TextBankInfo>
              <TextBankInfo>Note:</TextBankInfo>
            </Box>
          </Grid2>
          <Grid2 size={6}>
            <Box
              display="flex"
              flexDirection="column"
              justifyContent="flex-start"
              gap={2}
            >
              {loading ? (
                <>
                  <Skeleton variant="rounded" width="90%" height={20} />
                  <Skeleton variant="rounded" width="100%" height={20} />
                  <Skeleton variant="rounded" width="85%" height={20} />
                  <Skeleton variant="rounded" width="60%" height={20} />
                  <Skeleton variant="rounded" width="90%" height={20} />
                </>
              ) : (
                <>
                  <TextBankInfoValue>
                    {selectedbank?.account_name}
                  </TextBankInfoValue>
                  <TextBankInfoValue>
                    {selectedbank?.account_no}
                  </TextBankInfoValue>
                  <TextBankInfoValue>
                    {selectedbank?.bank_name}
                  </TextBankInfoValue>
                  <TextBankInfoValue>
                    ${Number(amount).toLocaleString("en-US")}
                  </TextBankInfoValue>
                  <TextBankInfoValue>{orderId}</TextBankInfoValue>
                </>
              )}
            </Box>
          </Grid2>
        </Grid2>
      </Box>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        gap={1}
        sx={{
          bgcolor: "background.default",
          minHeight: 200,
          color: "black",
          borderRadius: "16px",
          padding: "24px",
        }}
      >
        <Typography
          variant="caption"
          textAlign="center"
          maxWidth={72}
          color="rgba(100, 116, 139, 1)"
          fontWeight={600}
        >
          Scan QR to Payment
        </Typography>
        {loading ? (
          <Skeleton variant="rounded" width={160} height={150} />
        ) : (
          <></>
        )}
        <img
          id="qr"
          style={{ display: "none" }}
          width={180}
          height={170}
          src={`https://img.vietqr.io/image/${selectedbank.bank}-${
            selectedbank.account_no
          }-compact2.jpg?amount=${Math.ceil(
            amount * 23500
          )}&addInfo=${orderId}`}
          alt="qr"
          onLoad={() => {
            setLoading(false);
            document.getElementById("qr").style.display = "block";
          }}
        />
      </Box>
    </Box>
  );
}
